<div class="flex flex-col gap-6">
  <h4 class="text-4xl font-semibold leading-tight text-lWhite">Enviar arquivo de vídeo</h4>

  <div class="flex flex-col gap-2">
    <label [for]="config.inputId" class="text-sm font-medium text-lGray500">URL do vídeo</label>

    <div class="relative">
      @if (provider === 'youtube') {
        <span class="material-symbols-rounded material-symbols-outlined pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-base text-lGray500">smart_display</span>
      } @else {
        <span class="pointer-events-none absolute left-4 top-1/2 inline-flex h-4 w-4 -translate-y-1/2 items-center justify-center rounded-[4px] bg-lGray500 text-[11px] font-bold uppercase leading-none text-lGray950">v</span>
      }

      <input
        [id]="config.inputId"
        lInput
        type="url"
        maxlength="500"
        [formControl]="urlControl"
        (input)="onVideoUrlChange($any($event.target).value)"
        placeholder="Cole aqui a URL do vídeo"
        class="rounded-xl border-none pl-10 pr-12"
      />

      @if (isLoading) {
        <span class="material-symbols-rounded material-symbols-outlined pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 animate-spin text-xl text-lGray500">autorenew</span>
      } @else if (isLoaded) {
        <span class="material-symbols-rounded material-symbols-outlined pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-xl text-lGray300">check</span>
      }
    </div>
  </div>

  @if (preview) {
    <article class="flex flex-col gap-4 rounded-2xl bg-lGray950 p-5 lg:flex-row lg:items-start lg:gap-6">
      <img
        [src]="preview.thumbnailUrl"
        alt="Thumbnail do vídeo"
        class="h-44 w-full rounded-lg object-cover lg:h-40 lg:w-72"
      />

      <div class="flex min-w-0 flex-1 flex-col gap-3">
        <h5 class="truncate text-3xl font-semibold leading-9 text-lGray100">{{ preview.title }}</h5>

        <div class="flex items-center gap-2">
          <span class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-lGray700 text-xs font-semibold text-lWhite">
            {{ getChannelInitials(preview.channelName) }}
          </span>

          <a
            [href]="preview.channelUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="truncate text-sm text-lGray400 transition-colors hover:text-lGray100"
          >
            {{ preview.channelName }}
          </a>
        </div>

        @if (preview.description) {
          <p class="line-clamp-3 text-sm leading-6 text-lGray600">{{ preview.description }}</p>
        }
      </div>
    </article>
  }
</div>
